'use strict';

function trim(str) {
  return str.trim();
}

module.exports = trim;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/trim.js
// module id = 47
// module chunks = 0